import { render, staticRenderFns } from "./Otherbillar.vue?vue&type=template&id=f2d2185c"
import script from "./Otherbillar.vue?vue&type=script&lang=js"
export * from "./Otherbillar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports